import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
  },
  contentContainer: {
    width: '100%',
    display: 'flex',
    gap: '24px'
  },
  thumbnailContainer: {
    width: '250px',
    position: 'relative'
  },
  detailsContainer: {
    flex: '1 0 0',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  actionsContainer: {
    display: 'flex',
    gap: '16px'
  },
  documentTitle: {
    fontWeight: 600,
    padding: '2px 0 !important',
    fontSize: '24px',
    textTransform: 'capitalize',
    margin: '0'
  },
  detailsBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    alignItems: 'top'
  },
  detailBlockTitle: {
    fontSize: '18px',
    fontWeight: 600,
    margin: 0
  },
  detailsBlockContent: {
    margin: 0,
    fontSize: '16px',
    lineHeight: '18px',
    flex: '1 0 0',
    width: '100%'
  },
  tagContent: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px'
  },
  previewIframeContainer: {
    width: '100%',
    margin: '16px 0',
    paddingTop: '56.25%',
    position: 'relative',
    minHeight: 600,
    '&.fullscreen': {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      paddingTop: 0,
      zIndex: 1300,
      margin: 0,
      transitionDuration: '0.2s',

      '& $previewIframe': {
        width: '95%',
        height: '95%',
        top: '2.5%',
        left: '2.5%'
      },
      '& $previewBackdrop': {
        opacity: 0.8
      }
    }
  },
  previewBackdrop: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    backgroundColor: 'var(--color-neutral-800)',
    opacity: 0,
    transitionDuration: '0.2s'
  },
  previewIframe: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    borderRadius: '8px',
    border: '1px solid var(--color-neutral-300)',
    background: 'var(--color-white)'
  },
  previewFullscreenToggle: {
    position: 'absolute',
    top: '16px',
    right: '16px',
    zIndex: 10
  }
}))
